//src\Services\http\IndexService.ts
import { AwsParamsOne } from "../../Models/AccountAWS";
import { AffiliateDashboardResponse } from "../../types/AffiliateDashboardTypes";
import { IPublicLoginWithAwsRequest, IPublicLoginWithAwsResponse } from "../../types/Login.type";
import { SessionSorageInstance } from "../SessionStorageService";
import { baseUrl, extendHeaders, headers } from "./HelpService";


const PageUrl = baseUrl;


const login = (values: any): Promise<Response | null> => {
    var data = { email: values.email, password: values.password };
    return fetch(PageUrl + "login/", {
        method: "POST",
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify(data)
    })
        .then((response) => response.json())
        .then((data) => data as Response)
        .catch(error => {
            return null;
        });
};

const register = (values: any): Promise<Response | null> => {
    var data = {
        contact_hubspot_id: values['contactHubspotId'],
        user: {
            // username: values.userName,
            first_name: values.firstName,
            last_name: values.lastName,
            password: values.password,
            email: values.email,
            // phone: values.phone,
            // phone_prefix: values.phonePrefix
            phone: values.phoneNumber,
            country_code: `+${values.countryCode}`,
            free_text: values.freeText
        },
        account: {
            seller_id: values.sellerId,
            account_name: values.accountName,
            mws_auth_token: values.mWSauthToken,
            promotion_code: values.promotionCode,
            estimated_annual_revenue: values.estimatedAnnualRevenue,
            affiliate_id: values.affiliate_id ? Number(values.affiliate_id) : null
        }
    };
    return fetch(PageUrl + "register/", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify(data),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });

};

// const createAwsState = (aws_params: AwsParamsOne): Promise<Response | null> => {
//     return fetch(PageUrl + "createAwsState/", {
//         method: "POST",
//         headers: extendHeaders(),
//         body: JSON.stringify(aws_params)
//     })
//         .then((response) => response.json())
//         .then((data) => data as Response)
//         .catch(error => {
//             return null;
//         });
// };

const createAwsState = (account_id) => {
    return fetch(PageUrl + "createAwsState/", {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify({ "account_id": account_id })
    })
        .then((response) => response.json())
        .catch(error => {
            return null;
        });
};

const getIsValidCreditCard = (): Promise<Response | null> => {
    return fetch(PageUrl + "getIsValidCreditCard/", {
        method: "GET",
        headers: extendHeaders()
    })
        .then((response) => response.json())
        .then((data) => data as Response)
        .catch(error => {
            return null;
        });
};

const loginWithAws = (spapi_oauth_code: string, state: string,
    selling_partner_id: string, account_id: number): Promise<IPublicLoginWithAwsResponse | null> => {
    return fetch(PageUrl + "loginWithAws/", {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify(
            {
                "spapi_oauth_code": spapi_oauth_code,
                "state": state,
                "selling_partner_id": selling_partner_id,
                "account_id": account_id
            }
        )
    })
        .then((response) => response.json())
        .then((data) => data as Response)
        .catch(error => {
            return null;
        });
};

const publicLoginWithAws = (dataForLogin: IPublicLoginWithAwsRequest): Promise<IPublicLoginWithAwsResponse | null> => {
    return fetch(PageUrl + "publicLoginWithAws/", {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify(dataForLogin)
    })
        .then((response) => response.json())
        .then((data) => data as IPublicLoginWithAwsResponse)
        .catch(error => {
            return null;
        });
};


const getCaseTypes = (): Promise<Response | null> => {
    return fetch(PageUrl + "getCaseTypes/", {
        method: "GET",
        headers: extendHeaders()
    })
        .then((response) => response.json())
        .then((data) => data as Response)
        .catch(error => {
            return null;
        });
};

const checkIfExistsPromCode = (value: string) => {
    return fetch(PageUrl + `checkIfExistsPromCode/?promotion_code=${value}`, {
        method: "GET",
        headers: headers()
    })
        .then((response) => response.json())
        .catch(error => {
            return null;
        });
};

const sendVerificationCodeByEmail = (token: string) => {
    return fetch(PageUrl + 'sendVerificationCodeByEmail/', {
        method: "POST",
        headers: {
            'Authorization': token,
            "Content-type": "application/json"
        }
    })
        .then((response) => response.json())
        .catch(error => {
            return null;
        });
};

const verifyVerificationCode = (token: string, code: string) => {
    return fetch(PageUrl + 'verifyVerificationCode/', {
        method: "POST",
        headers: {
            'Authorization': token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({code: code})
    })
        .then((response) => response.json())
        .catch(error => {
            return null;
        });
};

const updateContactStatusInHubSpot = (hubspotVal) => {
    return fetch(PageUrl + 'updateContactStatusInHubSpot/', {
        method: "POST",
        headers:  {"Content-type": "application/json"},
        body: JSON.stringify({hubspot_val: hubspotVal})
    })
        .then((response) => response.json())
        .catch(error => {
            return null;
        });
};

const IndexService = {
    login,
    register,
    createAwsState,
    getIsValidCreditCard,
    loginWithAws,
    publicLoginWithAws,
    getCaseTypes,
    checkIfExistsPromCode,
    sendVerificationCodeByEmail,
    verifyVerificationCode,
    updateContactStatusInHubSpot,
};

export default IndexService;